<div [id]="name" class="form-group">
  <label
    *ngIf="label"
    [for]="name"
    [ngClass]="[
      validateMessage?.messageDisplay[name] ? 'text-red' : '',
      'd-flex flex-row justify-content-between'
    ]"
  >
    <div>
      {{ label }}

      <em
        *ngIf="tooltipTitle"
        data-toggle="tooltip"
        data-placement="auto"
        [title]="tooltipTitle"
        onmouseenter="$(this).tooltip('show')"
        class="fas fa-exclamation-circle text-danger"
      >
      </em>
    </div>

    <div *ngIf="allowActions">
      <!-- Botão de editar -->
      <button
        type="button"
        (click)="onEdit()"
        *ngIf="!isEditing"
        title="Editar"
        class="btn btn-sm btn-link p-0 ms-2"
      >
        <i class="fas fa-edit"></i>
      </button>

      <!-- Botões de salvar/cancelar -->
      <span *ngIf="isEditing" class="ms-2">
        <button
          class="btn btn-sm btn-link text-success p-0 me-1 mr-2"
          (click)="onSave()"
          title="Salvar"
          type="button"
        >
          <i class="fas fa-check"></i>
        </button>
        <button
          class="btn btn-sm btn-link text-danger p-0"
          (click)="onCancel()"
          title="Cancelar"
          type="button"
        >
          <i class="fas fa-times"></i>
        </button>
      </span>
    </div>
  </label>

  <div>
    <app-autocomplete
      [id]="'input-' + name"
      [form]="form"
      [url]="urlAutocomplete"
      [name]="name"
      [fieldName]="fieldName"
      [key]="key"
      [searchFor]="searchFor"
      class="custom-auto-complete"
      (onFocusOut)="updateErrors()"
      [ngClass]="setErrorValidate()"
    >
    </app-autocomplete>
  </div>

  <small
    class="form-text required"
    *ngIf="required && !validateMessage?.messageDisplay[name]"
  >
    *obrigatório
  </small>

  <small
    class="form-text text-red"
    *ngIf="validateMessage?.messageDisplay[name]"
    [innerHTML]="validateMessage?.messageDisplay[name]"
  >
  </small>
</div>
